import React from "react";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white">
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-xl mt-2">Page Not Found</p>
      <a
        href="/"
        className="mt-4 px-6 py-2 bg-[#BD0E0E] hover:bg-[#ffff] text-white hover:text-black rounded-lg no-underline"
      >
        Go Home
      </a>
    </div>
  );
};

export default NotFound;
